import { TLogger } from '@typescript/index';

declare const global: typeof globalThis & { logEnabled: boolean };

const logger = (() => {
  const checkIfLogsEnabled = () => {
    if (process.browser) {
      const search = global?.window?.location?.search;
      const enabled = search && new URLSearchParams(search).get('debug') === 'true';

      global.logEnabled = enabled || false;
      return global.logEnabled;
    }

    return false;
  };

  const isDev = process.env.NODE_ENV !== 'production';
  const isServer = typeof window === 'undefined';

  const logsColor = {
    info: 'background: blue; color: white;',
    warn: 'background: orange; color: white;',
    error: 'background: red; color: white;',
    trace: 'background: grey; color: black;',
    debug: 'background: green; color: white;',
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const print = (type: TLogger, ...messages: any[]) => {
    if (typeof global.logEnabled === 'undefined') {
      checkIfLogsEnabled();
    }

    if (global.logEnabled || isDev || isServer) {
      const logContext = isServer
        ? [...messages]
        : [`%c Logger(${type.toLowerCase()}):`, logsColor[type] ?? logsColor.info, ...messages];

      console[type](...logContext);
    }
  };

  return {
    debug: print.bind(null, 'debug'),
    info: print.bind(null, 'info'),
    warn: print.bind(null, 'warn'),
    error: print.bind(null, 'error'),
    trace: print.bind(null, 'trace'),
  };
})();

export default logger;
